import React, { useState, useMemo } from 'react';

var useIsHoveredOrFocused = function useIsHoveredOrFocused() {
  var _useState = useState(false),
      isHoveredOrFocused = _useState[0],
      setIsHoveredOrFocused = _useState[1];

  var hasHover = React.useRef(false);
  var hasFocus = React.useRef(false);
  var methods = useMemo(function () {
    return {
      onBlur: function onBlur() {
        hasFocus.current = false;
        setIsHoveredOrFocused(hasHover.current);
      },
      onFocus: function onFocus() {
        hasFocus.current = true;
        setIsHoveredOrFocused(true);
      },
      onMouseEnter: function onMouseEnter() {
        hasHover.current = true;
        setIsHoveredOrFocused(true);
      },
      onMouseLeave: function onMouseLeave() {
        hasHover.current = false;
        setIsHoveredOrFocused(hasFocus.current);
      }
    };
  }, []);
  return [isHoveredOrFocused, methods];
};

export default useIsHoveredOrFocused;